var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.512 1.00027H14.5145C14.939 0.992764 15.3514 1.14137 15.6735 1.41788C15.9957 1.6944 16.2051 2.07957 16.262 2.50027V7.75027C16.2051 8.17098 15.9957 8.55614 15.6735 8.83266C15.3514 9.10917 14.939 9.25778 14.5145 9.25027H12.512M7.26199 10.7503V13.7503C7.26199 14.347 7.49904 14.9193 7.921 15.3413C8.34295 15.7632 8.91525 16.0003 9.51199 16.0003L12.512 9.25027V1.00027H4.05199C3.69024 0.996182 3.3392 1.12297 3.06356 1.35727C2.78791 1.59157 2.60623 1.91759 2.55199 2.27527L1.51699 9.02527C1.48435 9.24025 1.49886 9.45976 1.55948 9.66858C1.62011 9.87741 1.72541 10.0706 1.86809 10.2346C2.01077 10.3987 2.18743 10.5298 2.38581 10.6189C2.58419 10.7079 2.79955 10.7527 3.01699 10.7503H7.26199Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownIcon);
export default __webpack_public_path__ + "static/media/thumbsDownIcon.0c6ecc242936758d816291b3c95c1645.svg";
export { ForwardRef as ReactComponent };